/**
 * /signup — Business Web. The screen is `SignUpView` (@tonnie/account); what
 * is Business's own comes from BUSINESS_ACCOUNT_PORTAL (../account-portal.tsx).
 *
 * BL-067: arriving from a team invitation (AcceptInvitePage stashed the
 * company and role), the page says "Join {company}" instead of creating a
 * company account — the backend skips provisioning a solo tenant for them.
 */
import { SignUpView } from '@tonnie/account';
import { useTranslation } from '@tonnie/locale';
import { useMemo, useState } from 'react';

function readPendingInvite(): { companyName: string; role: string } | null {
  try {
    const raw = sessionStorage.getItem('tonnie_pending_invitation_meta');
    return raw ? (JSON.parse(raw) as { companyName: string; role: string }) : null;
  } catch {
    return null;
  }
}

export default function SignupPage() {
  const { t } = useTranslation();
  const [pendingInvite] = useState(readPendingInvite);

  const heading = useMemo(
    () =>
      pendingInvite
        ? {
            title: t('business.auth.joinCompanyTitle', { company: pendingInvite.companyName }),
            description: t('business.auth.joinCompanySubtitle', {
              role:
                pendingInvite.role === 'business_admin'
                  ? t('business.auth.inviteRoleAdmin')
                  : t('business.auth.inviteRoleMember'),
            }),
          }
        : undefined,
    [pendingInvite, t]
  );

  return <SignUpView heading={heading} />;
}
